import React, { useState } from 'react';
import { api } from '../lib/axios';
import { toast } from 'sonner';

export default function PinPrompt({ onAuthenticated }) {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4) {
      toast.error('El PIN debe tener 4 dígitos');
      return;
    }
    
    setLoading(true);
    try {
      const res = await api.post('/check-pin', { pin });
      if (res.data.ok) {
        localStorage.setItem('delogo_access_pin', pin);
        toast.success('Acceso concedido');
        onAuthenticated(pin);
      }
    } catch (err) {
      toast.error('PIN incorrecto', { description: 'Inténtalo de nuevo' });
      setPin('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#FDFDFD] relative z-[2]">
      <div className="bg-[#141414] border border-[#27272A] p-8 rounded-xl shadow-2xl max-w-sm w-full mx-4 text-center">
        <h1 className="text-2xl font-bold tracking-tight mb-2">Acceso Restringido</h1>
        <p className="text-[#A1A1AA] text-sm mb-6">
          Ingresa el PIN de seguridad para acceder a DelogoStudio.
        </p>
        
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="password"
            maxLength={4}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/[^0-9]/g, ''))}
            placeholder="••••"
            className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-lg px-4 py-3 text-center text-2xl tracking-[1em] focus:outline-none focus:border-[#E4E4E7] transition-colors"
            autoFocus
            disabled={loading}
          />
          <button
            type="submit"
            disabled={pin.length !== 4 || loading}
            className="w-full bg-[#E4E4E7] text-[#0A0A0A] font-medium py-3 rounded-lg hover:bg-white disabled:opacity-50 transition-all"
          >
            {loading ? 'Verificando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
